import React from 'react';
import i18next from 'i18next';
import PendingButton from '../Button/PendingButton';
import apiForm from './apiForm';
import SumInput from '../SumInput/SumInput';
import Api from '../../api';
import FormErrors from './FormErrors';
import makeCancelable from '../../api/cancelable';
import PromocodeForm from './PromocodeForm';
import { ModalsConsumer } from '../Modal/ModalsProvider';
import dep from 'images/dep.jpg';

const DEPOSIT_MIN_SUM = app.config.deposit.min;
const DEPOSIT_MAX_SUM = app.config.deposit.max;

class DepositForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  onSubmit = (e) => {
    const { promise, cancel } = makeCancelable(
      Api.deposit(this.props.serializeForm(e.currentTarget))
    );
    this.requests.push(cancel);

    e.preventDefault();
    this.props.beforeSubmit();
    promise.then((response) => {
      if (response.status === 'success') {
        window.location.href = response.data.redirectTo;
      } else {
        this.props.afterSubmit(response);
      }
    });
  };

  render() {
    const {
      onInputChange,
      formState: { pending, errors, invalid, submitted, values },
    } = this.props;
    const blockSubmit =
      values.amount < DEPOSIT_MIN_SUM || values.amount > DEPOSIT_MAX_SUM;

    return (
      <div className="form deposit-form">
        <form onSubmit={this.onSubmit}>
          <span className="form__title form__title--center form__title--secondary">
            {i18next.t('deposit.title')}
          </span>
          <img width='100%' src={dep} />
          <SumInput
            sum={+values.amount}
            onChange={onInputChange.bind(this, 'amount')}
            min={DEPOSIT_MIN_SUM}
            max={DEPOSIT_MAX_SUM}
          />

          <FormErrors errors={errors} />

          <ModalsConsumer>
            {({ showModal }) => (
              <span
                className="form__link link"
                onClick={() => showModal(<PromocodeForm />)}
              >
                {i18next.t('deposit.promocode')}
              </span>
            )}
          </ModalsConsumer>

          <PendingButton
            tagName="button"
            className="form__submit"
            onClick={this.onSubmit}
            disabled={blockSubmit}
            pending={pending}
            done={submitted && errors.length === 0}
          >
            {i18next.t('deposit.action')}
          </PendingButton>
        </form>
      </div>
    );
  }
}

export default apiForm(DepositForm, {
  values: {
    amount: 300,
  },
});



// WEBPACK FOOTER //
// ./app/components/Form/DepositForm.jsx